import { Record } from 'immutable';
import { getSiteActions, getFormActions, getFormAnswersActions, getSettingsActions, updateDemographicsActions, actionTypes as demographicsActionTypes } from './demographics.actions';
import { actionTypes as authActionTypes } from '../auth/auth.actions';
import { actionTypes as loginActionTypes } from '../login/login.actions';
import * as api from '../api';

export const DemographicsState = Record({
  siteState: api.ApiCallState({}),
  formState: api.ApiCallState({}),
  answersState: api.ApiCallState({}),
  settingsState: api.ApiCallState({}),
  submitAnswersState: api.ApiCallState({})
});

export const demographicsReducer = (initialState = new DemographicsState(), action) => {
  var state = initialState.set('siteState',
    api.apiCallReducer(initialState.get('siteState'), action, getSiteActions));

  state = state.set('formState',
    api.apiCallReducer(state.get('formState'), action, getFormActions));

  state = state.set('answersState',
    api.apiCallReducer(state.get('answersState'), action, getFormAnswersActions));

  state = state.set('settingsState',
    api.apiCallReducer(state.get('settingsState'), action, getSettingsActions));

  state = state.set('submitAnswersState',
    api.apiCallReducer(state.get('submitAnswersState'), action, updateDemographicsActions));

  switch (action.type) {
    // When the user has logged out, or when the user's session expires,
    // clear out any existing demographic answers
    case authActionTypes.LOGOUT:
    case loginActionTypes.INVALIDATE_CURRENT_SESSION:
    case loginActionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
    case demographicsActionTypes.CLEAR_DEMOGRAPHICS_ANSWERS:
      return state.set('answersState', new api.ApiCallState({}));
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/demographics/demographics.reducer.js